import React from 'react';
import { object, node, func } from 'prop-types';
import { logError } from './datadogErrorHandling';

class DatadogErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    logError(error, {
      component_stack: errorInfo.componentStack,
      error_boundary: true,
      ...this.props.tags,
    });
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback({ error: this.state.error });
      }

      // Default fallback
      return (
        <div>
          <h2>Something went wrong.</h2>
          <p>An error occurred. Please refresh the page and try again.</p>
        </div>
      );
    }

    return this.props.children;
  }
}

DatadogErrorBoundary.propTypes = {
  children: node.isRequired,
  fallback: func,
  tags: object,
};

DatadogErrorBoundary.defaultProps = {
  fallback: null,
  tags: {},
};

export { DatadogErrorBoundary };
